import React from "react";

// Common
import { Table } from "react-lib/frameworks/Table";
import { ComponentPropsGetterR } from "react-table-6";

// Type
type TableSetupWorkShiftsTemplateProps = {
  // func
  onGetTrProps: ComponentPropsGetterR;
  // data
  tableData: Record<string, any>[];
};

const TableSetupWorkShiftsTemplate = (props: TableSetupWorkShiftsTemplateProps) => {
  return (
    <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
      <Table
        className="--rt-tbody-overflow-y-hidden"
        data={props.tableData}
        headers="Shift Code, Shift Name, Clock-in Time, Clock-out Time, Break Time, Total Working Hours, "
        keys="code, name, start_time, end_time, break_time, total_working, active"
        minRows={10}
        showPagination={false}
        sortable={false}
        style={{ height: "calc(80vh - 10rem)", overflowY: "auto" }}
        widths="^120, ^160, ^120, ^120, ^120, ^150, ^80"
        getTrProps={props.onGetTrProps}
      />
    </div>
  );
};

export default React.memo(TableSetupWorkShiftsTemplate);
